import { render, staticRenderFns } from "./DatasetUpdate.vue?vue&type=template&id=3a1fb70a"
import script from "./DatasetUpdate.vue?vue&type=script&lang=js"
export * from "./DatasetUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports